import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import Pagination from "../Pagination/Paginations";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const LeaveReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    leave_type: "ALL",
    leave_status: "2",
    action_type: "Fetch",
  });

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= FETCH LEAVE TYPES ================= */
  const fetchLeaveTypes = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/leave_types", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      setLeaveTypes(res.data?.data?.leave_type || []);
    } catch {
      toast.error("Failed to load leave types");
    }
  };

  useEffect(() => {
    fetchLeaveTypes();
  }, []);

  /* ================= FETCH REPORT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    // block repeat clicks while a request is already running
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);
    try {
      const res = await axios.post(
        API_BASE_URL + "/leave_report",
        filters,
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data.records || []);
      toast.success("Report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
        toastId: "leave-report-success",
      });
    } catch {
      toast.error("Error fetching leave report", { toastId: "leave-report-error" });
    } finally {
      loadingRef.current = false;
      setLoading(false);
    }
  };

  /* ================= SEARCH ================= */
  const filteredRecordsAll = records.filter((item) =>
    `${item.employee_id} ${item.employee_name} ${item.department} ${item.leave_type}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* Pagination (Previous / Next style) */
  const totalPages = Math.ceil(filteredRecordsAll.length / perPage);
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const filteredRecords = filteredRecordsAll.slice(indexOfFirst, indexOfLast);

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
    { name: "Employee ID", selector: r => r.employee_id, sortable: true },
    { name: "Employee Name", selector: r => r.employee_name, sortable: true },
    { name: "Department", selector: r => r.department, sortable: true },
    { name: "Applied On", selector: r => r.applied_on, sortable: true },
    { name: "From Date", selector: r => r.from_date, sortable: true },
    { name: "To Date", selector: r => r.to_date, sortable: true },
    { name: "No. of Days", selector: r => r.no_of_days, sortable: true, right: true },
    { name: "Leave Type", selector: r => r.leave_type, sortable: true },
    { name: "Incharge", selector: r => r.incharge_name },
    { name: "HOD", selector: r => r.hod_name },
    { name: "HR Approval", selector: r => r.hr_approval },
     { name: "Status", selector: r => r.status_label },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#7d858369",
        fontWeight: "bold",
      },
    },
  };

  return (
    <div className="container-fluid mt-4">
      {/* ================= FILTER CARD ================= */}
      <div className="card shadow-sm mb-4">
        <div className="card-header">
          <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
              <path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/>
              <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
              <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
            </svg>
            Leave Report
          </h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3 align-items-end">

           <div className="col-md">
  <label>From Date</label>

  <DatePicker
    selected={filters.start_date ? new Date(filters.start_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        start_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select From Date"
    className="form-control"
    maxDate={filters.end_date ? new Date(filters.end_date) : null}
  />
</div>

<div className="col-md">
  <label>To Date</label>

  <DatePicker
    selected={filters.end_date ? new Date(filters.end_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        end_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select To Date"
    className="form-control"
    minDate={filters.start_date ? new Date(filters.start_date) : null}
  />
</div>


              <div className="col-md">
                <label>Leave Type</label>
                <Select
                  options={leaveTypes.map(l => ({ value: l.value, label: l.label }))}
                  isClearable
                  placeholder="All"
                  value={leaveTypes
                    .map(l => ({ value: l.value, label: l.label }))
                    .find(o => o.value === filters.leave_type) || null}
                  onChange={(opt) =>
                    handleInput({
                      target: { name: "leave_type", value: opt ? opt.value : "ALL" },
                    })
                  }
                />
              </div>

              <div className="col-md">
                <label>Status</label>
                <select className="form-control"
                  style={{ height: "38px" }}
                  name="leave_status" value={filters.leave_status}
                  onChange={handleInput}>
                  <option value="1">Pending</option>
                    <option value="2">Approved</option>
                  <option value="3">Rejected</option>
                </select>
              </div>

              <div className="col-md-auto">
                <button className="btn btn-primary btn-sm" style={{ height: "38px" }} disabled={loading}>{loading ? "Loading..." : "Get"}</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="card">
        <div className="card-header text-danger">
          Employee Leave Report
        </div>
        <div className="card-body">

          <div className="d-flex justify-content-between mb-3">
            <DownloadButtons
              data={filteredRecordsAll}
              filename="Leave_Report"
            />

            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <EntriesSelector
                entriesPerPage={perPage}
                setEntriesPerPage={setPerPage}
                setCurrentPage={setCurrentPage}
              />
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search..."
                style={{ width: "220px" }}
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
              />
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredRecords}
            progressPending={loading}
            striped
            highlightOnHover
            dense
            customStyles={customStyles}
            noDataComponent={
              <div className="p-3 text-danger fw-bold">
                No records found
              </div>
            }
          />

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default LeaveReport;
